// Walk in Paris : points actifs de la galerie glissante des cartes produit
(function(){
  function update(slider){
    var dots=slider.parentElement.querySelector('.wip-card-dots'); if(!dots) return;
    var w=slider.clientWidth||1; var idx=Math.round(slider.scrollLeft/w);
    var ds=dots.children; for(var i=0;i<ds.length;i++){ ds[i].classList.toggle('is-active', i===idx); }
  }
  var pending=new WeakMap();
  document.addEventListener('scroll', function(e){
    var t=e.target; if(!(t instanceof Element) || !t.classList.contains('wip-card-slider')) return;
    if(pending.get(t)) return; pending.set(t,true);
    requestAnimationFrame(function(){ pending.set(t,false); update(t); });
  }, true);
})();

// Flèches des cartes produit (ordinateur)
document.addEventListener('click', function(e){
  var btn=e.target.closest('.wip-card-arrow'); if(!btn) return;
  e.preventDefault(); e.stopPropagation();
  var fig=btn.closest('.product-card__figure'); var s=fig&&fig.querySelector('.wip-card-slider'); if(!s) return;
  var w=s.clientWidth||1; var idx=Math.round(s.scrollLeft/w); var n=s.children.length;
  var next=(idx+parseInt(btn.dataset.dir,10)+n)%n;
  s.scrollTo({left:next*w,behavior:'smooth'});
});

// Wishlist Walk in Paris : sans application, enregistrée dans le navigateur du client
(function(){
  var KEY='wip_wishlist';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(list){ try{ localStorage.setItem(KEY, JSON.stringify(list)); }catch(e){} document.dispatchEvent(new CustomEvent('wip:wishlist', {detail:list})); }
  function has(h){ return read().indexOf(h)>-1; }
  function toggle(h){ var l=read(); var i=l.indexOf(h); if(i>-1) l.splice(i,1); else l.unshift(h); write(l); return i===-1; }
  window.wipWishlist={read:read,write:write,has:has,toggle:toggle};

  var HEART='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.8s-8-5.1-8-10.9A4.4 4.4 0 0 1 12 7.2a4.4 4.4 0 0 1 8 2.7c0 5.8-8 10.9-8 10.9Z"/></svg>';

  function makeBtn(h, cls){
    var b=document.createElement('button'); b.type='button'; b.className='wip-wish '+(cls||''); b.dataset.handle=h;
    b.innerHTML=HEART; b.setAttribute('aria-label','Enregistrer dans ma wishlist'); b.classList.toggle('is-on', has(h)); return b;
  }
  function decorateCards(root){
    (root||document).querySelectorAll('product-card[handle]').forEach(function(card){
      var fig=card.querySelector('.product-card__figure'); if(!fig||fig.querySelector('.wip-wish')) return;
      fig.appendChild(makeBtn(card.getAttribute('handle'),'wip-wish--card'));
    });
  }
  function decoratePdp(){
    var g=document.querySelector('.product-gallery'); if(!g||g.querySelector('.wip-wish')) return;
    var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
    g.appendChild(makeBtn(decodeURIComponent(m[1]),'wip-wish--pdp'));
  }
  function decorateHeader(){
    var li=document.querySelector('.header__search-link'); if(!li||document.querySelector('.wip-wish-link')) return;
    var l=document.createElement('li'); l.className='wip-wish-link';
    l.innerHTML='<a href="/pages/wishlist" aria-label="Ma wishlist">'+HEART.replace('width="20" height="20"','width="24" height="24" class="header__nav-icon icon"').replace('stroke-width="1"','stroke-width="1.5"')+'<span class="wip-wish-count"></span></a>';
    li.parentNode.insertBefore(l, li); refresh();
  }
  function refresh(){
    var l=read();
    document.querySelectorAll('.wip-wish').forEach(function(b){ b.classList.toggle('is-on', l.indexOf(b.dataset.handle)>-1); });
    var c=document.querySelector('.wip-wish-count'); if(c){ c.textContent=l.length||''; c.hidden=!l.length; }
  }
  // Klaviyo : événements "Added to Wishlist" / "Removed from Wishlist" (visiteur identifié par Klaviyo)
  function track(name, h){
    var k=window.klaviyo; if(!k||typeof k.push!=='function') return;
    fetch('/products/'+h+'.js').then(function(r){ return r.ok? r.json(): null; }).then(function(p){
      if(!p) return;
      var img=p.featured_image? p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=800':'';
      k.push(['track', name, {
        ProductName: p.title, ProductID: p.id, Handle: h, Price: (p.price/100).toFixed(2), Currency: 'EUR',
        ImageURL: img, URL: location.origin+'/products/'+h, Vendor: p.vendor, ProductType: p.type,
        WishlistCount: read().length, WishlistURL: location.origin+'/pages/wishlist', Language: ((window.Shopify&&Shopify.locale)||document.documentElement.lang||'fr').slice(0,2)
      }]);
    }).catch(function(){});
  }
  if(window._wipCustomer && window._wipCustomer.email && window.klaviyo){
    window.klaviyo.push(['identify', {email: window._wipCustomer.email, first_name: window._wipCustomer.first_name||'', last_name: window._wipCustomer.last_name||''}]);
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('.wip-wish'); if(!b) return;
    e.preventDefault(); e.stopPropagation(); var added=toggle(b.dataset.handle); b.classList.add('is-pop'); setTimeout(function(){ b.classList.remove('is-pop'); },300);
    track(added? 'Added to Wishlist':'Removed from Wishlist', b.dataset.handle);
  });
  document.addEventListener('wip:wishlist', refresh);
  // Mobile : le cœur apparaît pendant qu'on fait glisser les photos, puis s'efface
  var hideT=new WeakMap();
  document.addEventListener('scroll', function(e){
    var t=e.target; if(!(t instanceof Element)||!t.classList.contains('wip-card-slider')) return;
    var fig=t.closest('.product-card__figure'); if(!fig) return; fig.classList.add('wip-show-wish');
    clearTimeout(hideT.get(fig)); hideT.set(fig, setTimeout(function(){ fig.classList.remove('wip-show-wish'); },1800));
  }, true);
  function run(){ decorateCards(); decoratePdp(); decorateHeader(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function(){ decorateCards(); }).observe(document.documentElement, {childList:true, subtree:true});
})();

// Recherche : recommandations + dernier lookbook + dernière news tant que le champ est vide
(function(){
  var idle=document.getElementById('wip-search-idle'); if(!idle) return;
  var hs=document.querySelector('header-search'); if(!hs) return;
  var form=hs.querySelector('.header-search__form'); var input=hs.querySelector('input[type="search"]');
  if(form && idle.parentNode!==form.parentNode) form.parentNode.insertBefore(idle, form.nextSibling);
  function sync(){ var open=hs.hasAttribute('open'); idle.hidden=!(open && (!input || !input.value.trim())); }
  new MutationObserver(sync).observe(hs,{attributes:true,attributeFilter:['open']});
  if(input) input.addEventListener('input', sync); sync();
})();

// Fiche produit : taille M / 30 / 58 présélectionnée si disponible (sauf si une variante est déjà dans l'URL)
(function(){
  if(!/\/products\//.test(location.pathname) || /[?&]variant=/.test(location.search)) return;
  function run(){
    var picker=document.querySelector('variant-picker'); if(!picker) return;
    var inputs=[...picker.querySelectorAll('input[type=radio]')]; if(!inputs.length) return;
    var pref=['M','30','58'];
    for(var i=0;i<pref.length;i++){
      var inp=inputs.find(function(x){ return (x.value||'').trim().toUpperCase()===pref[i] && !x.disabled && !x.classList.contains('is-disabled') && !(x.closest('label')||{}).classList?.contains('is-disabled'); });
      if(inp){ if(!inp.checked){ inp.click(); } return; }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(run,50); }); else setTimeout(run,50);
})();

// Collections : bouton « Voir plus » à la place de la pagination numérotée
(function(){
  var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
  var LABEL=en?'Show more':'Voir plus', LOADING=en?'Loading…':'Chargement…';
  function pageOf(url){ var m=/[?&]page=(\d+)/.exec(url); return m?parseInt(m[1],10):1; }
  function nextLink(nav){
    var cur=pageOf(location.href); var links=nav.querySelectorAll('a[href*="page="]');
    for(var i=0;i<links.length;i++){ if(pageOf(links[i].getAttribute('href'))===cur+1) return links[i].href; }
    return null;
  }
  function setup(){
    var nav=document.querySelector('.pagination'); var list=document.querySelector('product-list.product-list');
    if(!nav||!list||nav.dataset.wipDone) return;
    nav.dataset.wipDone='1';
    var url=nextLink(nav); if(!url){ nav.hidden=true; return; }
    var btn=document.createElement('button'); btn.type='button'; btn.className='wip-more'; btn.textContent=LABEL;
    nav.hidden=true; nav.insertAdjacentElement('afterend',btn);
    btn.addEventListener('click',function(){
      if(!url) return; btn.disabled=true; btn.textContent=LOADING;
      fetch(url,{headers:{'Accept':'text/html'}}).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var nl=doc.querySelector('product-list.product-list'); var nn=doc.querySelector('.pagination');
        if(nl){ Array.prototype.slice.call(nl.children).forEach(function(c){ list.appendChild(document.importNode(c,true)); }); }
        var cur=pageOf(url); url=null;
        if(nn){ var links=nn.querySelectorAll('a[href*="page="]'); for(var i=0;i<links.length;i++){ if(pageOf(links[i].getAttribute('href'))===cur+1){ url=links[i].href; break; } } }
        try{ history.replaceState(null,'',url?url.replace(/([?&])page=\d+/,'$1page='+cur):location.href); }catch(e){}
        btn.disabled=false; btn.textContent=LABEL; if(!url) btn.remove();
      }).catch(function(){ btn.disabled=false; btn.textContent=LABEL; });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup); else setup();
  new MutationObserver(setup).observe(document.documentElement,{childList:true,subtree:true});
})();

// Retrait boutique : pas d'ajout au panier depuis l'étranger pour une taille non expédiable
(function(){
  var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
  var LABEL=en?'Not available for shipping':'Non disponible à l\'expédition';
  function apply(){
    var form=document.querySelector('.product-info form[action*="/cart/add"], product-form form'); if(!form) return;
    var btn=form.querySelector('button[type="submit"]'); if(!btn) return;
    var noShip=!!document.querySelector('.product-info .wip-no-ship, .wip-no-ship');
    if(noShip){ if(!btn.dataset.wipLabel){ btn.dataset.wipLabel=btn.innerHTML; } btn.disabled=true; btn.textContent=LABEL; btn.classList.add('wip-noship-btn'); }
    else if(btn.dataset.wipLabel){ btn.disabled=false; btn.innerHTML=btn.dataset.wipLabel; delete btn.dataset.wipLabel; btn.classList.remove('wip-noship-btn'); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',apply); else apply();
  new MutationObserver(apply).observe(document.documentElement,{childList:true,subtree:true});
})();

// Menu mobile : drapeaux FR / EN à la place du sélecteur de langue
(function(){
  var FR='<svg viewBox="0 0 24 16" width="20" height="14" aria-hidden="true"><rect width="8" height="16" fill="#1d3a8a"/><rect x="8" width="8" height="16" fill="#fff"/><rect x="16" width="8" height="16" fill="#c8102e"/></svg>';
  var GB='<svg viewBox="0 0 60 40" width="20" height="14" aria-hidden="true"><rect width="60" height="40" fill="#1d3a8a"/><path d="M0 0L60 40M60 0L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0L60 40M60 0L0 40" stroke="#c8102e" stroke-width="3"/><path d="M30 0V40M0 20H60" stroke="#fff" stroke-width="12"/><path d="M30 0V40M0 20H60" stroke="#c8102e" stroke-width="6"/></svg>';
  function build(){
    document.querySelectorAll('form[id^="localization-form-header-sidebar"][id$="-locale"]').forEach(function(form){
      var wrap=form.closest('.relative'); if(!wrap||wrap.dataset.wipLang) return; wrap.dataset.wipLang='1';
      var cur=(document.documentElement.lang||'fr').slice(0,2).toLowerCase();
      var box=document.createElement('div'); box.className='wip-lang';
      [['fr',FR,'FR'],['en',GB,'EN']].forEach(function(o){
        var b=form.querySelector('button[name="locale_code"][value="'+o[0]+'"]'); if(!b) return;
        var a=document.createElement('button'); a.type='button'; a.className='wip-lang__btn'+(cur===o[0]?' is-active':''); a.innerHTML=o[1]+'<span>'+o[2]+'</span>';
        a.addEventListener('click',function(){ b.click(); }); box.appendChild(a);
      });
      if(box.children.length){ wrap.classList.add('wip-lang-hidden'); wrap.insertAdjacentElement('afterend',box); }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',build); else build();
  new MutationObserver(build).observe(document.documentElement,{childList:true,subtree:true});
})();

// Menu mobile : bas de menu façon ALD (newsletter, liens, livraison vers, langue)
(function(){
  var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
  var T=en?{news:'Newsletter',ph:'Your email',sub:'Subscribe',ship:'Shipping to',links:[['Customer service','/en/pages/contact'],['Delivery and returns','/en/pages/politiques-de-retours-echanges'],['Stockists','/en/pages/revendeur'],['Instagram','https://www.instagram.com/walkinparis/'],['Legal notices','/en/pages/mentions-legales']]}
                :{news:'Newsletter',ph:'Votre e-mail',sub:"S'inscrire",ship:'Livraison vers',links:[['Service client','/pages/contact'],['Livraison et retours','/pages/politiques-de-retours-echanges'],['Points de vente','/pages/revendeur'],['Instagram','https://www.instagram.com/walkinparis/'],['Mentions légales','/pages/mentions-legales']]};
  function build(){
    var foot=document.querySelector('#sidebar-menu .header-sidebar__footer'); if(!foot||foot.dataset.wipDone) return; foot.dataset.wipDone='1';
    var box=document.createElement('div'); box.className='wip-sb';
    box.innerHTML='<form method="post" action="/contact#newsletter" class="wip-sb__news" accept-charset="UTF-8"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter"><input type="email" name="contact[email]" required placeholder="'+T.ph+'" aria-label="'+T.news+'"><button type="submit">'+T.sub+'</button></form>'
      +'<ul class="wip-sb__links">'+T.links.map(function(l){return '<li><a href="'+l[1]+'"'+(l[1].indexOf('http')===0?' target="_blank" rel="noopener"':'')+'>'+l[0]+'</a></li>'}).join('')+'</ul>';
    var loc=foot.querySelector('.localization-selectors');
    if(loc){ foot.insertBefore(box,loc); } else { foot.appendChild(box); }
    // Livraison vers : ligne pleine largeur autour du sélecteur de pays
    var cform=foot.querySelector('form[id^="localization-form-header-sidebar"][id$="-country"]');
    if(cform){ var wrap=cform.closest('.relative'); var btn=wrap&&wrap.querySelector('button.localization-toggle');
      if(btn&&!wrap.dataset.wipShip){ wrap.dataset.wipShip='1'; wrap.classList.add('wip-ship'); var lab=document.createElement('span'); lab.className='wip-ship__label'; lab.textContent=T.ship+' : '; btn.insertBefore(lab,btn.firstChild); } }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',build); else build();
  new MutationObserver(build).observe(document.documentElement,{childList:true,subtree:true});
  // Footer du site : même libellé devant le pays
  function foot(){ document.querySelectorAll('.footer form[id^="localization-form"][id$="-country"], footer form[id^="localization-form"][id$="-country"]').forEach(function(f){ var w=f.closest('.relative'); var b=w&&w.querySelector('button.localization-toggle'); if(b&&!b.dataset.wipShip){ b.dataset.wipShip='1'; var l=document.createElement('span'); l.className='wip-ship__label'; l.textContent=T.ship+' : '; b.insertBefore(l,b.firstChild); } }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',foot); else foot();
})();

/* News "La boutique" : renvoie vers la page La boutique */
(function(){
  var re=/^(\/[a-z]{2})?\/blogs\/journal\/la-boutique(-32-rue-yves-toudic)?\/?$/;
  function target(pre){ return (pre||'')+'/pages/la-boutique'; }
  var m=location.pathname.match(re);
  if(m){ location.replace(target(m[1])); return; }
  function fix(){ document.querySelectorAll('a[href*="/blogs/journal/la-boutique"]').forEach(function(a){ try{ var u=new URL(a.getAttribute('href'),location.origin); var mm=u.pathname.match(re); if(mm) a.setAttribute('href',target(mm[1])); }catch(e){} }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
  new MutationObserver(fix).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Combiné avec : images nettes (le thème charge des vignettes de 60 à 180 px) */
(function(){
  function sharpen(){
    document.querySelectorAll('.complementary-products__product-list img:not([data-wip-sharp])').forEach(function(img){
      var src=img.currentSrc||img.src||(img.getAttribute('srcset')||'').split(',')[0].trim().split(' ')[0];
      if(!src||(src.indexOf('cdn.shopify.com')<0&&src.indexOf('/cdn/shop/')<0)) return;
      var base=src.replace(/([?&])width=\d+/,'$1').replace(/[?&]$/,'').replace(/[?&]crop=[^&]*/,'');
      var sep=base.indexOf('?')>-1?'&':'?';
      img.setAttribute('srcset',[400,600,800,1000].map(function(w){return base+sep+'width='+w+' '+w+'w';}).join(', '));
      img.setAttribute('sizes','(max-width:699px) 46vw, 360px');
      img.src=base+sep+'width=800';
      img.setAttribute('data-wip-sharp','1');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sharpen); else sharpen();
  new MutationObserver(sharpen).observe(document.documentElement,{childList:true,subtree:true});
})();
